import { useMutation } from "@tanstack/react-query";
import httpRequest from "app/lib/axios/index";
import { LOAN_APPLICATION } from "app/constants/apiEndPoints";

interface ResendOtpRequest {
  [key: string]: any;
}

const loan = async (data: ResendOtpRequest): Promise<any> => {
  const response = await httpRequest.post(`${LOAN_APPLICATION}`, data);
  return response.data;
};

export const useLoanApplication = () => {
  return useMutation<any, Error, ResendOtpRequest>({
    mutationFn: loan,
  });
};
